import {SetGetFreespin} from './thunk/setGetFreespin';
import {SetGetListFreespin} from './thunk/setGetListFreespin';
import {SetPostIssueFreespin} from './thunk/setPostIssueFreespin';
import {SetPostResultDenomination} from './thunk/setPostResultDenomination'

export const Thunks = {
    SetGetFreespin,
    SetGetListFreespin,
    SetPostIssueFreespin,
    SetPostResultDenomination
}